// A branch is a loose end of the constellation, a star with one line: the
// shape's endpoints (scoring/shape.ts), counting any an alignment grants.
import type { ConstellationCtx } from '../types';

export function branches(c: ConstellationCtx): number {
  return c.shape.endpoints;
}
